import { render, staticRenderFns } from "./AttentionRequiredInvoices.vue?vue&type=template&id=2e0b8aa0&scoped=true&"
import script from "./AttentionRequiredInvoices.vue?vue&type=script&lang=js&"
export * from "./AttentionRequiredInvoices.vue?vue&type=script&lang=js&"
import style0 from "./AttentionRequiredInvoices.vue?vue&type=style&index=0&id=2e0b8aa0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e0b8aa0",
  null
  
)

export default component.exports